"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var data;
        (function (data_1) {
            var feed;
            (function (feed) {
                class InitArgs {
                    constructor() {
                        this.dataFeedPageSize = 0;
                        this.dateFilter = appn.emptyString;
                        this.userFilterId = 0;
                        this.formFilterId = appn.emptyGuid;
                        this.dataFeedAjax = appn.emptyString;
                    }
                }
                let _initArgs;
                let _timeLineCount;
                let _currentResultCount = 0;
                let _currentPageNumber = 0;
                let _map;
                let _searchValue;
                let _error;
                function init(args) {
                    _initArgs = args;
                    appn.dateFilterMini.init(_initArgs.dateFilter, requestDataFeedAjax);
                    addEvents();
                    requestDataFeedAjax();
                    enableDisableSearchBox();
                    $('.feed-search-container').append(appn.popover.hint(appn.emptyString, T('Filter results where the selected forms <b>Answers</b> start with a keyword typed in here.'), 'datafeed-hint-input-right'));
                    appn.popover.init();
                    _timeLineCount = $('div.feed-result-count');
                    appn.saveMeState.init(function (element) {
                        if (element) {
                            if (element.id === "UserFilterId")
                                _initArgs.userFilterId = 0;
                            else if (element.id === "FormFilterId")
                                _initArgs.formFilterId = appn.emptyGuid;
                        }
                        enableDisableSearchBox();
                        _currentPageNumber = 0;
                        _currentResultCount = 0;
                        setResultCount(0);
                        requestDataFeedAjax();
                    }, function () {
                        _currentPageNumber = 0;
                        _currentResultCount = 0;
                        setResultCount(0);
                        requestDataFeedAjax();
                    }, '.reset-filters-container-feed');
                    appn.select.init();
                    appn.select.init({ selector: '#UserFilterId', minimumResultsForSearch: '25' });
                }
                feed.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_map)
                        return;
                    _map.invalidateSize();
                });
                function addEvents() {
                    $('#SearchId').off().on('keydown', function (event) {
                        if (!(event.keyCode === 13) || !event.target || !(event.target.type === 'search'))
                            return;
                        event.preventDefault();
                        _searchValue = $('#SearchId').val();
                        $('#SearchId').blur();
                        _currentPageNumber = 0;
                        _currentResultCount = 0;
                        setResultCount(0);
                        requestDataFeedAjax();
                    });
                }
                function addTimelineEvents() {
                    $('.btn.load-more-data').off().on('click', function () {
                        _currentPageNumber++;
                        requestDataFeedAjax(true);
                    });
                    $('.btn-show-map').on('click', function (e) {
                        e.preventDefault();
                        const timeLineItem = $(this).closest('.timeline-item');
                        const lat = $(this).data('maplat');
                        const long = $(this).data('maplong');
                        const mapId = $(this).data('mapid');
                        const timeLineItemHeader = timeLineItem.find('.timeline-header');
                        timeLineItemHeader.addClass('timeline-header-no-border');
                        timeLineItem.find('.timeline-body').removeClass('d-none');
                        initmap(mapId, lat, long);
                        const timelineItemHeight = 100;
                        timeLineItem.find('.leaflet-container').css('height', timelineItemHeight + 'px');
                        _map.invalidateSize();
                        $(this).remove();
                    });
                    appn.dialog.singleEntryExport.init();
                }
                function enableDisableSearchBox() {
                    const currentSelectedForm = $('#FormFilterId option:selected');
                    if (currentSelectedForm.val())
                        appn.ui.enableElement($('#SearchId'));
                    else {
                        $('#SearchId').val(appn.emptyString);
                        appn.ui.disableElement($('#SearchId'));
                    }
                }
                function requestDataFeedAjax(isRequestMore = false) {
                    appn.dialog.showLoading();
                    const timeline = $('div.timeline');
                    if (!isRequestMore)
                        _currentResultCount = 0;
                    if (_currentPageNumber === 0)
                        timeline.html(appn.emptyString);
                    else
                        $('.timelineend, .load-more, .timelinespinning').remove();
                    let url = _initArgs.dataFeedAjax + '?v=' + new Date().getTime();
                    const appnDateFilterValue = appn.dateFilterMini.getStateOrDefault();
                    url += `&DateFilter=${appnDateFilterValue.type}`;
                    url += `&fromDate=${appnDateFilterValue.fromDate}`;
                    url += `&toDate=${appnDateFilterValue.toDate}`;
                    url += `&PageNumber=${_currentPageNumber}`;
                    if (_initArgs.userFilterId > 0) {
                        url += `&UserFilterId=${_initArgs.userFilterId}`;
                        appn.saveMeState.resetState();
                    }
                    else {
                        const userValue = appn.dataTable.getStateOrDefault('UserFilterId', appn.emptyString);
                        if (userValue)
                            url += `&UserFilterId=${userValue.value}`;
                    }
                    if (_initArgs.formFilterId.hasValue() && _initArgs.formFilterId !== appn.emptyGuid) {
                        url += `&FormFilterId=${_initArgs.formFilterId}`;
                        appn.saveMeState.resetState();
                    }
                    else {
                        const formValue = appn.dataTable.getStateOrDefault('FormFilterId', appn.emptyString);
                        if (formValue)
                            url += `&FormFilterId=${formValue.value}`;
                    }
                    _searchValue = $('#SearchId').val();
                    if (_searchValue)
                        url += `&SearchId=${encodeURIComponent(_searchValue)}`;
                    appn.ajax.post({
                        url: url,
                        dataType: 'json',
                        done: function (dataParsed) {
                            $('.descreteSpin').remove();
                            const userFilterText = $('#UserFilterId option:selected').text();
                            const formFilterText = $('#FormFilterId option:selected').text();
                            const searchFilterText = dataParsed.SearchId;
                            const dateFilterText = $('.appnDateFilterMini option:selected').text();
                            if (!dataParsed.Results || dataParsed.Results.length === 0) {
                                timeline.append(getTimelineNoDataHtml(userFilterText, formFilterText, dateFilterText, searchFilterText));
                                timeline.append(getTimelineEndHtml());
                                appn.ui.tryResetFiltersEvent();
                                appn.dialog.hideLoading();
                                return;
                            }
                            let timelineHtmlToRender = appn.emptyString;
                            if (dataParsed.Results) {
                                if (_currentPageNumber > 0)
                                    timeline.append(getTimelineDelimiterHtml(_currentResultCount));
                                _currentResultCount = _currentResultCount + dataParsed.Results.length;
                                dataParsed.Results.forEach(function (result, index) {
                                    const thisResult = result;
                                    timelineHtmlToRender += getTimelineItemHtml(index, result);
                                    timeline.append(timelineHtmlToRender);
                                    timelineHtmlToRender = appn.emptyString;
                                });
                            }
                            if (_currentResultCount < dataParsed.TotalRows)
                                timeline.append(getTimelineLoadMoreButton());
                            else
                                timeline.append(getTimelineNoDataHtml(userFilterText, formFilterText, dateFilterText, searchFilterText));
                            timeline.append(getTimelineEndHtml());
                            $('abbr.timeago').timeago();
                            appn.ui.initOpenOnClick();
                            addTimelineEvents();
                            setResultCount(_currentResultCount);
                            appn.ui.tryResetFiltersEvent();
                            appn.dialog.hideLoading();
                        },
                        fail: function () {
                            appn.dialog.alert({
                                modalColor: 'modal-danger',
                                title: T('Data Feed Load Failed'),
                                message: T('Failed to load feed data.  Please sign out and sign in again.  Contact support if this problem persists.'),
                                buttons: {
                                    ok: {
                                        label: '<span>' + T('OK') + '</span>',
                                        className: 'btn-success'
                                    }
                                },
                                autoHeaderIcon: false
                            });
                            appn.dialog.hideLoading();
                        },
                        always: function () {
                            enableDisableSearchBox();
                        }
                    });
                }
                function setResultCount(currentCount) {
                    _timeLineCount.text(T('Showing {0} results', currentCount));
                }
                function getTimelineLoadMoreButton() {
                    const btn = appn.elementBuilder.createElement('button', ['load-more-data', 'btn', 'btn-info'], undefined, undefined, `${appn.elementBuilder.createElement('i', ['fa', 'fa-sync-alt']).outerHTML} ${T('Load More Results')}`);
                    const item = appn.elementBuilder.createElement('div', ['time-label', 'center-block', 'load-more']);
                    item.append(btn);
                    return item.outerHTML;
                }
                function hasLongAndLat(result) {
                    return result.FormEntryDeets.Latitude !== 0 && result.FormEntryDeets.Longitude !== 0;
                }
                function hasTask(result) {
                    return result.FormEntryDeets.TaskId;
                }
                function getTimelineItemHtml(ii, dataFeedResult) {
                    let fileHtml = appn.emptyString;
                    if (dataFeedResult.FilesTotalDisplay > 0)
                        fileHtml = '<span class="datafeed-mediafiles">' + (dataFeedResult.FilesUpLoadedDisplay === dataFeedResult.FilesTotalDisplay ? '<i class="fa fa-check text-success" ></i> ' : '<i class="fa fa-sync-alt text-warning m-1" ></i>') + T('{0} of {1} media files uploaded successfully', dataFeedResult.FilesUpLoadedDisplay, dataFeedResult.FilesTotalDisplay) + '</span>';
                    let mapHtmls = appn.emptyString;
                    const mapId = `map${_currentPageNumber}-${ii}`;
                    if (hasLongAndLat(dataFeedResult))
                        mapHtmls = `<div class="" id="${mapId}" style="height: 102px !important;"></div>`;
                    let templates;
                    if (dataFeedResult.TemplateFileNames && dataFeedResult.TemplateFileNames.length > 0)
                        templates = JSON.stringify(dataFeedResult.TemplateFileNames);
                    const mainFooterContent = buildTimelineFooterContent(dataFeedResult.ViewEntryUrl, dataFeedResult.LogsEntryUrl, dataFeedResult.ViewEntryInTable, mapHtmls, dataFeedResult.FormEntryDeets.Id, dataFeedResult.ReceivedTimeAgo, dataFeedResult.ReceivedOnDisplay, dataFeedResult.ScreenName ? dataFeedResult.ExportEntryUrl : undefined, templates, hasTask(dataFeedResult) ? dataFeedResult.TaskUrl : undefined, dataFeedResult, mapId);
                    return buildTimelineItem(getFormIconHtml(dataFeedResult), dataFeedResult.CompleteBy, dataFeedResult.ViewEntryUrl, mapHtmls, mainFooterContent, dataFeedResult.ScreenName, fileHtml, dataFeedResult.ReceivedTimeAgo, dataFeedResult.ReceivedOnDisplay, dataFeedResult.FormVersion).outerHTML;
                }
                function buildTimelineItem(itemIconHTML, completeBy, link, itemMapHTML, footerContent, screenName, fileHTML, recievedTime, receivedDisplay, version) {
                    const compositeIcon = appn.elementBuilder.createElement('i', 'fa feed-timeline-image', undefined, undefined, itemIconHTML);
                    const headerLink = appn.elementBuilder.createElement('a', undefined, undefined, [['href', link], ['onclick', 'return appn.ui.popup(this)']], screenName !== null && screenName !== void 0 ? screenName : T('Form Entry'));
                    const itemHeader = appn.elementBuilder.createElement('h3', 'timeline-header', undefined, undefined, T('{0} completed', completeBy) + ` ${headerLink.outerHTML} <span class="text-muted font-size-smaller-3 data-feed-version">${version}</span>`);
                    const itemBody = appn.elementBuilder.createElement('div', `timeline-body p-0 d-none`);
                    const itemMap = appn.elementBuilder.createElement('div', 'feed-map-container', undefined, undefined, itemMapHTML);
                    const itemRow = appn.elementBuilder.createElement('div', 'timeline-item');
                    const timeSpan = appn.elementBuilder.createElement('span', 'time', undefined, undefined, `<i class="fa fa-clock"></i> ${T('Received')} <abbr class="timeago" title="${recievedTime}Z">${receivedDisplay}</abbr>`);
                    itemRow.append(timeSpan);
                    itemRow.append(itemHeader);
                    itemRow.append(itemBody);
                    if (itemMapHTML)
                        itemBody.append(itemMap);
                    const itemFooter = appn.elementBuilder.createElement('div', 'timeline-footer pt-1');
                    itemFooter.append(footerContent);
                    if (fileHTML)
                        itemFooter.append($.parseHTML(fileHTML)[0]);
                    itemRow.append(itemFooter);
                    const item = appn.elementBuilder.createElement('div');
                    item.append(compositeIcon);
                    item.append(itemRow);
                    return item;
                }
                function buildTimelineFooterContent(viewLink, logLink, tableLink, itemMapHTML, entryId, recievedTime, receivedDisplay, exportLink, templates, taskLink, dataFeedResult, mapId) {
                    const mainContainer = appn.elementBuilder.createElement('div', '');
                    if (taskLink) {
                        const tskAction = appn.elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 pl-0', undefined, [['href', taskLink !== null && taskLink !== void 0 ? taskLink : appn.emptyString], ['target', '_blank'], ['rel', 'noopener noreferrer']], '<i class="fa fa-paper-plane m-1" ></i>' + T('View Related Task'));
                        mainContainer.append(tskAction);
                    }
                    const viwAction = appn.elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 pl-0', undefined, [['href', viewLink], ['onclick', 'return appn.ui.popup(this)']], '<i class="fa fa-eye m-1" ></i>' + T('View Entry'));
                    const expAction = appn.elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 singleEntryExportLink', undefined, [['href', exportLink !== null && exportLink !== void 0 ? exportLink : appn.emptyString], ['data-entryid', entryId], ['data-templatefiles', templates !== null && templates !== void 0 ? templates : appn.emptyString]], '<i class="fa fa-upload m-1" ></i>' + T('Export Data'));
                    const logAction = appn.elementBuilder.createElement('a', 'btn btn-link btn-sm py-0', undefined, [['href', 'javascript:void(null);'], ['data-modal-iframe', logLink], ['data-size', 'modal-xl']], '<i class="fa fa-history m-1" ></i>' + T('Connector Logs'));
                    const tblAction = appn.elementBuilder.createElement('a', 'btn btn-link btn-sm py-0', undefined, [['href', tableLink], ['target', '_blank'], ['rel', 'noopener noreferrer']], '<i class="fa fa-th-list m-1"></i>' + T('Table View'));
                    mainContainer.append(viwAction);
                    if (exportLink)
                        mainContainer.append(expAction);
                    mainContainer.append(logAction);
                    mainContainer.append(tblAction);
                    if (itemMapHTML)
                        mainContainer.append(appn.elementBuilder.createElement('a', 'btn btn-link btn-sm py-0 btn-show-map', undefined, [['data-maplat', dataFeedResult === null || dataFeedResult === void 0 ? void 0 : dataFeedResult.FormEntryDeets.Latitude.toString()], ['data-maplong', dataFeedResult === null || dataFeedResult === void 0 ? void 0 : dataFeedResult.FormEntryDeets.Longitude.toString()], ['data-mapid', mapId]], '<i class="fa fa-map-marked m-1" ></i>' + T('Show Map')));
                    return mainContainer;
                }
                function getFormIconHtml(dataFeedResult) {
                    if (!dataFeedResult.FormIconUrl)
                        return appn.emptyString;
                    return `<img class="img-fluid img-timeline-header-icon" src="${dataFeedResult.FormIconUrl}" />`;
                }
                function getTimelineDelimiterHtml(resultsAbove = 0) {
                    return '<div class="time-label">' +
                        `<span class="bg-info"><i class="fa fa-arrow-up"></i> ${T('Showing {0} results above', resultsAbove)}</span>` +
                        '</div>';
                }
                function getTimelineEndHtml() {
                    return '<div class="timelineend"><i class="fa fa-clock bg-navy"></i></div>';
                }
                function getTimelineNoDataHtml(userFilterText, formFilterText, dateFilterText, searchFilterText) {
                    let filtersAppliedText = T('Showing Results for:') + ` ${formFilterText}, ${userFilterText}, ${dateFilterText}`;
                    if (searchFilterText && searchFilterText.length > 0)
                        filtersAppliedText += `, ${T('where answers start with')} "${searchFilterText}"`;
                    _error = $('.timeline-item .timeline-body h4.text-gray');
                    if (_error.length > 0) {
                        _error.text(filtersAppliedText);
                        return appn.emptyString;
                    }
                    return '<div> ' +
                        '<div class="timeline-item no-data-found">' +
                        '<div class="timeline-body text-center text-gray lead">' +
                        `<span class="font-size-larger-2"><i class="fa fa-search text-danger mr-2"></i>${_currentResultCount === 0 ? T('No Data Found') : T('No Further Data Found')}</span>` +
                        `<span class="font-size-smaller-1">${filtersAppliedText}</span>` +
                        `<span class="font-size-smaller-1">${T(`Try <a href='#' class='link-reset-filters'>resetting</a> the filters`)}</span>` +
                        '</div>' +
                        '</div>' +
                        '</div>';
                }
                function initmap(mapId, lat, long) {
                    _map = appn.ui.mapInit(mapId, lat, long, 13, true);
                    const icon = L.divIcon({
                        html: '<div class="appn-mapPin"></div><div class="appn-mapShadow"></div>'
                    });
                    const entriesll = new L.LatLng(lat, long);
                    const entriesmark = new L.Marker(entriesll, { icon: icon });
                    _map === null || _map === void 0 ? void 0 : _map.addLayer(entriesmark);
                }
            })(feed = data_1.feed || (data_1.feed = {}));
        })(data = views.data || (views.data = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
